import * as React from "react";

const SvgHeart = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.318 5.318a4.5 4.5 0 0 0 0 6.364L12 19.364l7.682-7.682a4.5 4.5 0 0 0-6.364-6.364L12 6.636l-1.318-1.318a4.5 4.5 0 0 0-6.364 0Z"
      stroke={color}
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgHeart;
